import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, HostListener, NgModule } from '@angular/core';
import { mixinInputEvent, mixinChangeEvent, mixinBlurEvent, mixinFocusEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/one-time-pin/one-time-pin';

function FadvOneTimePinValidator(spaces = 6) {
    return function (control) {
        const value = control.value;
        // it's untouched with no value, the default state
        if (!value)
            return { required: true };
        if (!RegExp(`\\d{${spaces}}`).test(value))
            return { input: true };
        return null;
    };
}
class FadvOneTimePinComponent extends mixinInputEvent(mixinChangeEvent(mixinBlurEvent(mixinFocusEvent(mixinFormControl(FadvBaseComponent))))) {
    constructor(el) {
        super(el);
        this.value = '';
    }
    ngAfterContentInit() {
        this.registerFormValueChangeHandler((value) => {
            this.elementRef.nativeElement.value = value;
        });
        this.registerSubscription(this.onChanges, (changes) => {
            if (changes['value'].currentValue === undefined) {
                this.value = '';
            }
        });
        this.registerSubscription(this.blurred, () => this.onTouched());
        this.registerSubscription(this.inputChanged, () => this.reportChange(this.elementRef.nativeElement.value));
        this.registerSubscription(this.changed, () => this.reportChange(this.elementRef.nativeElement.value));
    }
    handleEnterPress(event) {
        const input = event.target;
        const parentForm = input.closest('form');
        if (parentForm === null || parentForm === void 0 ? void 0 : parentForm.contains(input)) {
            parentForm.requestSubmit();
        }
    }
}
FadvOneTimePinComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvOneTimePinComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvOneTimePinComponent, selector: "fadv-one-time-pin", inputs: { value: "value", disabled: "disabled", spaces: "spaces", valid: "valid", invalid: "invalid", autofocus: "autofocus" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed", inputChanged: "inputChanged" }, host: { listeners: { "keydown.enter": "handleEnterPress($event)" } }, providers: [createFormControlProvider(FadvOneTimePinComponent)], usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvOneTimePinComponent.prototype, "spaces", void 0);
__decorate([
    Forward()
], FadvOneTimePinComponent.prototype, "valid", void 0);
__decorate([
    Forward()
], FadvOneTimePinComponent.prototype, "invalid", void 0);
__decorate([
    Forward()
], FadvOneTimePinComponent.prototype, "autofocus", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-one-time-pin',
                    template: '',
                    providers: [createFormControlProvider(FadvOneTimePinComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, inputEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { spaces: [{
                type: Input
            }], valid: [{
                type: Input
            }], invalid: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], handleEnterPress: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }] } });

class FadvOneTimePinModule {
}
FadvOneTimePinModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvOneTimePinModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinModule, declarations: [FadvOneTimePinComponent], imports: [FadvCommonModule], exports: [FadvOneTimePinComponent] });
FadvOneTimePinModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvOneTimePinModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvOneTimePinComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvOneTimePinComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvOneTimePinComponent, FadvOneTimePinModule, FadvOneTimePinValidator };
